import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { startGoogleLogin } from "@/components/Auth";
import { PasswordLoginForm, RegisterForm } from "@/components/PasswordAuth";

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
);

export default function Login() {
  const { t, user, lang, config, site } = useApp();
  const [mode, setMode] = useState("login");
  const [back] = useState(() => localStorage.getItem("ce_return") || "/account");
  const id = lang === "id";
  if (user) {
    localStorage.removeItem("ce_return");
    return <Navigate to={back} replace />;
  }
  const perks = id
    ? `Member mendapat diskon ${config.member_discount_pct || 0}% di setiap pesanan + kupon selamat datang ${config.welcome_discount_pct || 0}% saat pertama daftar.`
    : `Members get ${config.member_discount_pct || 0}% off every order + a ${config.welcome_discount_pct || 0}% welcome coupon when they sign up.`;
  return (
    <div className="min-h-[70vh] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src={site?.login_image || "https://images.unsplash.com/photo-1637486069202-b1163268c240?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"} alt="" className="absolute inset-0 w-full h-full object-cover" data-testid="login-image" />
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <div className="max-w-sm w-full space-y-7">
          <h1 className="font-serif text-5xl">{mode === "login" ? t("login") : (id ? "Daftar" : "Register")}</h1>
          <p className="text-sm bg-[#F6F2EE] border-l-2 border-[#8C4F27] px-4 py-3" data-testid="member-perks">{perks}</p>
          <div className="grid grid-cols-2 border border-[#E6DFD5] text-sm" data-testid="auth-mode-toggle">
            {[["login", id ? "Masuk" : "Sign in"], ["register", id ? "Daftar" : "Register"]].map(([k, l]) => (
              <button key={k} onClick={() => setMode(k)} data-testid={`auth-mode-${k}`} className={`py-2.5 transition-colors ${mode === k ? "bg-[#3B220C] text-white" : "text-[#6E6259]"}`}>{l}</button>
            ))}
          </div>
          <button onClick={() => startGoogleLogin(back)} data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-3 border border-[#3B220C] py-4 hover:bg-[#3B220C] hover:text-white transition-colors">
            <GoogleIcon />{id ? "Lanjut dengan Google" : "Continue with Google"}
          </button>
          <div className="border-t border-[#E6DFD5] pt-7">{mode === "login" ? <PasswordLoginForm /> : <RegisterForm />}</div>
          <p className="text-xs text-[#6E6259]">{id ? "Barang fisik juga bisa dibeli langsung tanpa akun (beli sebagai tamu)." : "Physical goods can also be bought as a guest."}</p>
        </div>
      </div>
    </div>
  );
}
